let currentProduct = {
    title : '',
    description : '',
    category : '',
    subCategory : '',
    img : '',
    price : '',
    sizeType : '',
    sizes : {

    },
    status : '',
    timestamp : ''
}

const productValidation = [
    {
        name : 'title',
        required : true,
        minLength : 8,
        type : 'text',
    },
    {
        name : 'description',
        required : true,
        minLength : 8,
        type : 'text',
    },
    {
        name : 'category',
        required : true,
        minLength : 1000,
        type : 'text',
    },
    {
        name : 'subCategory',
        required : true,
        minLength : 1000,
        type : 'text',
    },
    {
        name : 'price',
        required : true,
        type : 'number',
    }
]

let imgFile;
let productCode;

const validateForm = (formSchema, item) => {
    let validate = []
    let valid = true
    formSchema.forEach(schema => {
        switch (schema.type) {
            case 'text':
                if (item[schema.name] === undefined || item[schema.name] === ''){
                    validate.push(false);
                    $('#' + schema.name).addClass('error');
                } else {
                    $('#' + schema.name).removeClass('error');
                }
            case 'number':
                if (item[schema.name] === undefined || item[schema.name] === ''){
                    validate.push(false);
                    $('#' + schema.name).addClass('error');
                } else {
                    $('#' + schema.name).removeClass('error');
                }
                break;
            case 'list':
                if (item[schema.name] === undefined || item[schema.name] === ''){
                    if (Object.values(item[schema.name].sizes).length === 0) {
                        validate.push(false);
                        $('#' + schema.name).addClass('error');
                    } else {
                        $('#' + schema.name).removeClass('error');
                    }
                }
                break;
            default:
        }
    })
    if (validate.includes(false)){
        valid = false
    }
    return valid
}

let initialProduct = Object.assign(currentProduct)

let currentSize;

const openForm = (id,formName) => {
    $('.table-wrapper').addClass('d-none');
    $(`.${tabName}-toolbar`).addClass('d-none');
    $('.form-wrapper').removeClass('d-none');
    $(`.${formName}-toolbar`).removeClass('d-none');
    $(`.${formName}-form`).removeClass('d-none');
    if (formName === 'new-product'){
        productCode = undefined;
        if (id !== undefined){
            productCode = id;
            Object.values(products).forEach(product => {
                if (product.id === id){
                    currentProduct = product;
                }
            })
            createSubCategoryOptions(currentProduct.category, currentProduct.subCategory);
            let productKeys = Object.keys(currentProduct);
            $('#subCategory').removeAttr('disabled');
            productKeys.forEach(key => {
                if (key !== 'img'){
                    $('#' + key).val(currentProduct[key]);
                }
            })
            $('.loaded-img-wrapper').html(`<img style="width:100%" src="${currentProduct.img}">`);
            $('.loaded-img-wrapper').css('border','1px solid black')
            if (!currentProduct.sizes) { currentProduct.sizes = [] }
            Object.keys(currentProduct.sizes).forEach(size => {
                $('.size-tables').find('tbody').append(`
                    <tr class="row-${size}">
                        <td><small>${size}</small></td>
                        <td class="sizes-availables-count"><small>${currentProduct.sizes[size]}</small></td>
                        <td>
                            <button class="bg-red formal small text-white" onClick="decSize('${size}',this)"><small>-</small></button>&nbsp;
                            <button class="bg-green formal small text-white" onClick="incSize('${size}',this)"><small>+</small></button>&nbsp;
                        </td>
                    </tr>`
                )
            })
        }
    }
    if (formName === 'manage-order'){
        const orderRef = database.ref('/orders/' + id)
        orderRef.on('value', snapshot => {
            $('.order-overview').html('<h3 class="mb-4"><strong>Riepilogo Ordine</strong></h3>')
            $('.order-overview-info').html('<h3 class="mb-4"><strong>Informazioni</strong></h3>')
            $('.order-overview-address').html('<h3 class="mb-4"><strong>Spedizione</strong></h3>')
            $('.order-overview').append(getOrderListTemplate(snapshot.val()));
            $('.order-overview-info').append(getOrderInfoTemplate(snapshot.val(), id));
            $('.order-overview-address').append(getShippingTemplate(snapshot.val(), id));
        })
    }
    squareIt()
}

const closeForm = (formName,reset) => {
    $('.table-wrapper').removeClass('d-none');
    $(`.${tabName}-toolbar`).removeClass('d-none');
    $('.form-wrapper').addClass('d-none');
    $(`.${formName}-toolbar`).addClass('d-none');
    $(`.${formName}-form`).addClass('d-none');
    $(`.${formName}-form`).find('input').val('')
    $(`.${formName}-form`).find('select').val('')
    $(`.${formName}-form`).find('textarea').val('')
    $(`.${formName}-form`).find('tbody').html('');
    $('.loaded-img-wrapper').html('');
    currentProduct = Object.assign(initialProduct)
    if (formName === 'manage-form'){
        $('.order-overview').html('<h3 class="mb-4"><strong>Riepilogo Ordine</strong></h3>')
        $('.order-overview-info').html('<h3 class="mb-4"><strong>Informazioni</strong></h3>')
        $('.order-overview-address').html('<h3 class="mb-4"><strong>Spedizione</strong></h3>')
        currentOrderId = undefined;
    }
    squareIt()
}

const editProduct = (productId) => {
    openForm(productId,'new-product')
}

const newProductInput = (name, value) => {
    currentProduct[name] = value;
}

const createCategoryOptions = () => {
    const categoriesRef = database.ref('/categories/').orderByKey();
    categoriesRef.once('value', function(snapshot){
        let categories = snapshot.val();
        if (categories !== null && categories !== undefined){
            let categoryNames = Object.keys(categories);
            $('#category').find('option').not('.default-select-opt').remove();
            categoryNames.forEach(category => {
                $('#category').append(`<option value="${category}">${category}</option>`);
                $('#parent').append(`<option value="${category}">${category}</option>`);
                $('#parent').val(newCategory.parent);
            })
        }
    })
}

const createSubCategoryOptions = (category, subCategory) => {
    const subCategoryRef = database.ref('categories/' + category + '/subCategories/').orderByKey();
    subCategoryRef.once('value', (snapshot) => {
        let subCategories = Object.values(snapshot.val());
        $('#subCategory').find('option').not('.default-select-opt').remove();
        subCategories.forEach(subCategory => {
            $('#subCategory').append(`<option>${subCategory}</option>`);
        })
        $('#subCategory').removeAttr('disabled')
        if (subCategory){
          $('#subCategory').val(subCategory)
        }
    })
}

const loadSizeTypes = () => {
    const sizeTypesRef = database.ref('/sizeTypes/').orderByKey();
    sizeTypesRef.once('value', snapshot => {
        let sizeTypes = snapshot.val();
        let sizeTypesNames = Object.keys(sizeTypes);
        $('#sizeType').find('option').not('.default-select-opt').remove();
        sizeTypesNames.forEach(sizeType => {
            $('#sizeType').append(`<option>${sizeType}</option>`)
        })
    })
}

const loadSizes = (sizeType) => {
    currentProduct.sizeTypes = sizeType;
    const sizesRef = database.ref('/sizeTypes/' + sizeType).orderByKey();
    sizesRef.once('value', snapshot => {
        let sizes = snapshot.val();
        let sizesNames = Object.keys(sizes);
        $('#size').find('option').not('.default-select-opt').remove();
        sizesNames.forEach(size => {
            $('#size').append(`<option>${size}</option>`)
        })
        $('#size').removeAttr('disabled')
    })
}

const addAvailableSize = () => {
    if (currentSize !== undefined && currentSize !== ''){
        if (!Object.keys(currentProduct.sizes).includes(currentSize)){
            currentProduct.sizes[currentSize] = 1;
            let sizesNames = Object.keys(currentProduct.sizes);
            $('.size-tables').find('tbody').find('tr').remove();
            sizesNames.forEach(size => {
                $('.size-tables').find('tbody').append(`
                    <tr class="row-${size}">
                        <td><small>${size}</small></td>
                        <td class="sizes-availables-count"><small>${currentProduct.sizes[size]}</small></td>
                        <td>
                            <button class="bg-red formal small text-white" onClick="decSize('${size}',this)"><small>-</small></button>&nbsp;
                            <button class="bg-green formal small text-white" onClick="incSize('${size}',this)"><small>+</small></button>&nbsp;
                        </td>
                    </tr>`
                )
            })
        } else {
            alert('hai già aggiunto questa misura, puoi modificarne la disponibilità dalla tabella sotto')
        }
    }
}

const readURL = (input) => {
  if (input.files && input.files[0]) {
    var reader = new FileReader();
    reader.onload = function(e) {
      imgFile = input.files[0];
      $('.loaded-img-wrapper').html(`<img style="width:100%" src="${e.target.result}">`);
      $('.loaded-img-wrapper').css('border','1px solid black')
    }
    reader.readAsDataURL(input.files[0]);
  }
}

const incSize = (size,el) => {
    currentProduct.sizes[size] += 1;
    $(el).closest('tr').find('.sizes-availables-count').html(currentProduct.sizes[size])
}

const decSize = (size,el) => {
    currentProduct.sizes[size] -= 1;
    if (currentProduct.sizes[size] === 0){
        $(el).closest('tr').remove()
        delete currentProduct.sizes[size]
    } else {
        $(el).closest('tr').find('.sizes-availables-count').html(currentProduct.sizes[size])
    }
}

const squareIt = () => {
    $('.squared-el').each(function(){
        let w = $(this).width();
        $(this).css('min-height',w + 'px')
    })
}

const saveProduct = (type) => {
    console.log(productCode)
    if (validateForm(productValidation, currentProduct)){
        currentProduct.timestamp = getMillisecondStamp();
        currentProduct.price = Number(currentProduct.price)
        switch (type) {
            case 'draft':
                currentProduct.status = 'bozza'
                break;
            case 'public':
                currentProduct.status = 'pubblico'
                break;
            default:
        }
        if (productCode !== undefined && productCode !== null && productCode !== 'undefined'){
            console.log('edit')
            const productRef = database.ref('/products/' + productCode)
            productRef.set(currentProduct).then(() => {
                let itemImageRef = storage.ref('/images/products/' + productCode + '/cover.jpg')
                if (imgFile) {
                    itemImageRef.put(imgFile).then(snap => {
                        itemImageRef.getDownloadURL().then(url => {
                            let productUrlRef = database.ref('products/' + productCode + '/img/')
                            productUrlRef.set(url).then(() => {
                                closeForm('new-product');
                            });
                        })
                    })
                }
                closeForm('new-product');
            })
        } else {
            console.log('new')
            const productRef = database.ref('/products/')
            productRef.push(currentProduct).then(snapshot => {
                let newKey = snapshot.key
                let itemImageRef = storage.ref('/images/products/' + newKey + '/cover.jpg')
                itemImageRef.put(imgFile).then(snap => {
                    itemImageRef.getDownloadURL().then(url => {
                        let productUrlRef = database.ref('products/' + newKey + '/img/')
                        productUrlRef.set(url).then(() => {
                            closeForm('new-product');
                        });
                    })
                })
            })
        }
    } else {

    }
}

const removeProduct = (productId) => {
    const productRef = database.ref('/products/' + productId).remove();
}

$(window).on('resize',function(){
    squareIt()
})

$('#category').on('change', function(){
    let category = $(this).val();
    createSubCategoryOptions(category)
})

$('#sizeType').on('change', function(){
    let sizeType = $(this).val();
    loadSizes(sizeType)
})

$('#size').on('change', function(){
    currentSize = $(this).val()
})

$("#img").on ('change', function() {
  readURL(this);
});

$('.new-product-input').on('input', function(){
    newProductInput($(this).attr('id'),$(this).val())
})



createCategoryOptions();
loadSizeTypes();
squareIt()
